import { useEffect, useState } from "react";
import { StageEditorPage } from "./StageEditorPage.js";
import { loadOneStage } from "./customStagesClient.js";
import type { StoredStage } from "./stageRecord.js";

export function StageEditorLoader({ id }: { id: string }) {
  const [record, setRecord] = useState<StoredStage | null | undefined>(undefined);
  useEffect(() => {
    void loadOneStage(id, localStorage).then(setRecord);
  }, [id]);
  if (record === undefined) return <p className="maker-hub">読み込み中</p>;
  if (!record) {
    return (
      <div className="stage maker-page">
        <div className="device">
          <main className="maker-hub">
            <p>見つからない</p>
            <a href="/stage-maker">一覧へ</a>
          </main>
        </div>
      </div>
    );
  }
  return <StageEditorPage record={record} />;
}
